export default function Hero({ data }) {
  return (
    <section id="home" style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      padding: "8rem 3rem 5rem", position: "relative", overflow: "hidden",
    }}>
      <div style={{
        position: "absolute", inset: 0, pointerEvents: "none",
        background: "radial-gradient(ellipse 60% 50% at 70% 40%, #f0ede8 0%, transparent 70%)",
      }} />

      <div style={{
        maxWidth: 1100, margin: "0 auto", width: "100%",
        display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4rem", alignItems: "center",
        position: "relative",
      }} className="hero-inner">

        {/* Left */}
        <div style={{ animation: "fadeUp 0.8s ease both" }}>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "0.5rem",
            fontSize: "0.8rem", fontWeight: 400, letterSpacing: "0.1em",
            textTransform: "uppercase", color: "var(--text-muted)", marginBottom: "1.5rem",
          }}>
            <span style={{ display: "inline-block", width: 24, height: 1, background: "var(--text-muted)" }} />
            {data.tagline}
          </div>

          <h1 style={{
            fontFamily: "var(--serif)", fontSize: "clamp(3rem, 5vw, 4.5rem)",
            lineHeight: 1.08, letterSpacing: "-0.02em", marginBottom: "1.5rem",
          }}>
            {data.headline[0]}<br />
            <em style={{ fontStyle: "italic", color: "var(--text-muted)" }}>{data.headline[1]}</em><br />
            {data.headline[2]}
          </h1>

          <p style={{
            fontSize: "1.05rem", color: "var(--text-secondary)", lineHeight: 1.7,
            maxWidth: 460, marginBottom: "2.5rem", fontWeight: 300,
          }}>
            I craft fast, elegant, production-ready iOS & Android apps. Eight years turning complex ideas into seamless mobile experiences that people actually love.
          </p>

          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            <a href="#work" style={{
              background: "var(--text-main)", color: "var(--white)",
              padding: "0.875rem 2rem", borderRadius: "999px",
              fontSize: "0.9rem", fontWeight: 500, transition: "opacity 0.2s",
            }}
              onMouseOver={e => e.target.style.opacity = "0.8"}
              onMouseOut={e => e.target.style.opacity = "1"}
            >View my work</a>
            <a href="#contact" style={{
              border: "1px solid var(--border)", color: "var(--text-secondary)",
              padding: "0.875rem 2rem", borderRadius: "999px",
              fontSize: "0.9rem", fontWeight: 400,
            }}>Get in touch</a>
          </div>
        </div>

        {/* Right */}
        <div style={{
          display: "flex", flexDirection: "column", gap: "1rem", alignItems: "flex-end",
          animation: "fadeUp 0.8s ease 0.15s both",
        }}>
          {data.stats.map((s, i) => (
            <div key={i} style={{
              background: "var(--off-white)", border: "1px solid var(--border)",
              borderRadius: "var(--radius)", padding: "1.25rem 1.5rem",
              width: 200, marginRight: i === 1 ? "2.5rem" : i === 2 ? "1rem" : 0,
            }}>
              <div style={{ fontFamily: "var(--serif)", fontSize: "2.5rem", lineHeight: 1, marginBottom: "0.3rem" }}>{s.num}</div>
              <div style={{ fontSize: "0.8rem", color: "var(--text-muted)", fontWeight: 300 }}>{s.label}</div>
            </div>
          ))}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", justifyContent: "flex-end", maxWidth: 320, marginTop: "0.5rem" }}>
            {data.chips.map((c) => (
              <span key={c} style={{
                background: "var(--white)", border: "1px solid var(--border)",
                borderRadius: "999px", padding: "0.3rem 0.9rem",
                fontSize: "0.78rem", color: "var(--text-secondary)",
              }}>{c}</span>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div style={{
        position: "absolute", bottom: "3rem", left: "50%",
        display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem",
        fontSize: "0.72rem", letterSpacing: "0.1em", textTransform: "uppercase",
        color: "var(--text-muted)", animation: "bounce 2s ease-in-out infinite",
      }}>
        <span>Scroll</span>
        <div style={{ width: 1, height: 40, background: "linear-gradient(to bottom, var(--text-muted), transparent)" }} />
      </div>

      <style>{`
        @media (max-width: 768px) {
          .hero-inner { grid-template-columns: 1fr !important; gap: 2rem !important; }
        }
      `}</style>
    </section>
  );
}
